import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormGroup, NgForm, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { forkJoin, interval, take, takeLast } from 'rxjs';
import { ConfirmOtpEmailComponent } from 'src/app/auth/confirm-otp-email/confirm-otp-email.component';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { OkcancelDialogComponent } from 'src/app/shared/components/okcancel-dialog/okcancel-dialog.component';
import { PublicidadPopupDialogComponent } from 'src/app/shared/components/publicidad-popup-dialog/publicidad-popup-dialog.component';
import { AppstyleService } from 'src/core/appstyle/appstyle.service';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { MascotaService } from 'src/core/mascota/mascota.service';
import { DatosMascotaActualizar, MascotasPorUsuarioCliente } from 'src/core/mascota/mascota.types';
import { ResponseValidateOtp } from 'src/core/message-service/message-service.types';
import { RazaService } from 'src/core/raza/raza.service';
import { Raza } from 'src/core/raza/raza.types';
import { TallaService } from 'src/core/talla/talla.service';
import { Talla } from 'src/core/talla/talla.types';
import { AuthService } from 'src/core/auth/auth.service';
import { UserService } from 'src/core/user/user.service';
import { DatosRecuperacionContrasenna, DatosUsuarioParaActualizar, User } from 'src/core/user/user.types';

const PUBLICIDAD_DISPONIBLE = [
  'assets/images/publicidad/gabrica-publi-1.jpeg',
  'assets/images/publicidad/gabrica-publi-2.jpeg',
  'assets/images/publicidad/gabrica-publi-3.jpeg',
  'assets/images/publicidad/gabrica-publi-4.jpeg'
];

const PUBLICIDAD_VISTA_KEY = 'pet24PublicidadCuentaVista';

@Component({
  selector: 'app-cuenta',
  templateUrl: './cuenta.component.html',
  styleUrls: ['./cuenta.component.css']
})
export class CuentaComponent extends CommonComponent implements OnInit {

  @ViewChild('userProfile') userProfileNgForm: NgForm;

  // formularios nuevos que se deben de llenar 
  errorMessage: string | undefined;
  datosDeUsuarioForm: UntypedFormGroup;
  //Mascotas Existentes
  datosMascotasRegistradasForm: UntypedFormGroup;
  mascotaFormGroup: FormArray;
  // Mascotas nuevas
  datosNuevasMascotasRegistradasForm: UntypedFormGroup;
  datosMascotasNuevas: FormArray;

  //otras variables
  user: User | undefined;



  formularioPrincipal: UntypedFormGroup;

  preguntaSeguridadValidada: boolean = false;
  otpValidado: boolean = false;

  clickUpdate: boolean = false;
  show: boolean = false;
  mascotasDelUsuario: MascotasPorUsuarioCliente[] = [];

  listaTallas: Talla[];
  listaRazas: Raza[];
  datosUsuario: DatosUsuarioParaActualizar;
  datosMascotaActualizar: DatosMascotaActualizar;

  constructor(
    private _consultaService: ConsultaService,
    private _mascotaService: MascotaService,
    private _formBuilder: UntypedFormBuilder,
    private _tallasService: TallaService,
    private _razaService: RazaService,
    _snackBar: MatSnackBar,
    private _styleService: AppstyleService,
    private _dialog: MatDialog,
    private _authService: AuthService,
  ) {
    super(_snackBar);
    this._styleService.backgroudcolor = 'bg-white';
  }


  ngOnInit(): void {
    this.inicializarFormularioEjemplo(); // ---- ejemplo 
    this.cargarDatosUsuariosEjemplo();// ---- ejemplo 

    this.obtenerInformacionDelUsuario();

    this.incializarFormularioUsuario();
    this.inicializarDatosDemascotasDelUsuario();
    this.inicializarDatosNuevasMascotas();
    this.datosMascotasNuevas = this._formBuilder.array([]);

    this.cargarDatosPreviosMascotasUsuario();
    this.mostrarPublicidad();
  }

  private mostrarPublicidad(): void {
    if (sessionStorage.getItem(PUBLICIDAD_VISTA_KEY)) {
      return;
    }
    sessionStorage.setItem(PUBLICIDAD_VISTA_KEY, 'true');

    const image = PUBLICIDAD_DISPONIBLE[Math.floor(Math.random() * PUBLICIDAD_DISPONIBLE.length)];

    this._dialog.open(PublicidadPopupDialogComponent, {
      data: { image, alt: 'Publicidad PET24' },
      panelClass: 'pet24-publicidad-popup',
      ariaLabel: 'Publicidad PET24',
      maxWidth: '90vw'
    });
  }


  incializarFormularioUsuario() {
    this.datosDeUsuarioForm = this._formBuilder.group({
      id: [''],
      nombre: ['', [Validators.required]],
      contrasena: ['', Validators.required],
      correo: ['', [Validators.required, Validators.email]],
      preguntaSeguridad: ['', Validators.required],
      respuestaSeguridad: ['', Validators.required],
      numeroTelefono: ['', Validators.required]
    });
  }
  /** datos nuevos. */
  inicializarDatosDemascotasDelUsuario() {
    this.datosMascotasRegistradasForm = this._formBuilder.group({
      informacionMascotas: this._formBuilder.array([])
    });
  }
  inicializarDatosNuevasMascotas() {
    this.datosNuevasMascotasRegistradasForm = this._formBuilder.group({
      informacionNuevasMascotas: this._formBuilder.array([])
    });
  }

  get informacionMascotas(): FormArray {
    return this.datosMascotasRegistradasForm.get('informacionMascotas') as UntypedFormArray;
  }
  get informacionNuevasMascotas(): FormArray {
    return this.datosNuevasMascotasRegistradasForm.get('informacionNuevasMascotas') as UntypedFormArray;
  }

  crearInformacionMascotasFormGroup(): UntypedFormGroup {
    return this._formBuilder.group({
      idMascota: ['',],
      nombre: ['', Validators.required],
      sexo: ['', Validators.required],
      especie: ['', Validators.required],
      idRaza: ['', Validators.required],
      idTalla: ['', Validators.required],
    });
  }

  temporizador(): void {
    this.otpValidado = true;
    const intervalos = 10 * 60;
    interval(100)
      .pipe(
        take(intervalos),
        takeLast(1)
      )
      .subscribe(() => {
        console.log('Han pasado 10 minutos');
        alert("Debe volver verificar nuevamente su identidad");
        this.otpValidado = false;
        this.preguntaSeguridadValidada = false;
      });
  }

  /** -------------------------- */


  inicializarFormularioEjemplo() {
    this.formularioPrincipal = this._formBuilder.group({
      informacionUsuarios: this._formBuilder.array([])
    });
  }
  get informacionUsuarios(): UntypedFormArray {
    return this.formularioPrincipal.get('informacionUsuarios') as UntypedFormArray;
  }
  crearInformacionUsuarioFormGroup(): UntypedFormGroup {
    return this._formBuilder.group({
      nombre: ['', Validators.required],
      edad: ['', [Validators.required, Validators.min(18)]],
      email: ['', [Validators.required, Validators.email]],
      profesion: ['']
    });
  }
  mostrarDatos() {
    console.log(this.formularioPrincipal.value);
  }
  cargarDatosUsuariosEjemplo() {
    // Datos fijos de usuarios
    const usuariosFijos = [
      { nombre: 'Ana García', edad: 28, email: 'ana@example.com', profesion: 'Ingeniera' },
      { nombre: 'Juan Pérez', edad: 35, email: 'juan@example.com', profesion: 'Médico' },
      { nombre: 'María López', edad: 42, email: 'maria@example.com', profesion: 'Abogada' }
    ];

    // Limpia el FormArray existente
    this.informacionUsuarios.clear();

    // Agrega un FormGroup por cada usuario
    usuariosFijos.forEach(usuario => {
      const usuarioFormGroup = this.crearInformacionUsuarioFormGroup();
      usuarioFormGroup.patchValue(usuario);
      this.informacionUsuarios.push(usuarioFormGroup);
    });
  }

  // funcion interna
  obtenerIDUsuarioDatosLocales() {
    const userSessionString = localStorage.getItem('userSession');
    if (userSessionString) {
      const userSession = JSON.parse(userSessionString);
      const userId = userSession?.id;
      return userId;
    } else {
      console.error('No se encontró la clave "userSession" en localStorage');
    }
  }
  // temporal
  cargarDataManual() {
    this.obtenerInformacionDelUsuario();

  }
  cargarDatosPreviosMascotasUsuario(): void {
    forkJoin({
      mascotas: this._mascotaService.getMascotasPorIdUsuairo(this.obtenerIDUsuarioDatosLocales()),
      tallas: this._tallasService.getTallas(),
      razas: this._razaService.getRazas()
    }).subscribe(({ mascotas, tallas, razas }) => {
      this.mascotasDelUsuario = mascotas;
      this.listaTallas = tallas;
      this.listaRazas = razas;
      this.cargarDatosMascotas();
    });
  }
  // funcion que se debe llamar postCarga de datos 
  cargarDatosMascotas() {
    this.informacionMascotas.clear();
    this.mascotasDelUsuario.forEach(mascotas => {
      const mascotasFormGruop = this.crearInformacionMascotasFormGroup();
      console.log('->', mascotas);
      mascotasFormGruop.get('idMascota')?.setValue(mascotas.idMascota);
      mascotasFormGruop.get('nombre')?.setValue(mascotas.nombreMascota);
      mascotasFormGruop.get('sexo')?.setValue(1);
      mascotasFormGruop.get('especie')?.setValue(1);
      mascotasFormGruop.get('idRaza')?.setValue(mascotas.idRaza);
      mascotasFormGruop.get('idTalla')?.setValue(mascotas.idTalla);
      this.informacionMascotas.push(mascotasFormGruop);
    });
  }
  cargarNuevaMascotaUsuario() {
    const mascotasFormGruop = this.crearInformacionMascotasFormGroup();
    console.log('->', 'Dato para mascota nueva');
    mascotasFormGruop.get('nombre')?.setValue('');
    mascotasFormGruop.get('sexo')?.setValue(1);
    mascotasFormGruop.get('especie')?.setValue(1);
    mascotasFormGruop.get('idRaza')?.setValue('');
    mascotasFormGruop.get('idTalla')?.setValue('');
    mascotasFormGruop.get('estado')?.setValue(true)
    this.informacionNuevasMascotas.push(mascotasFormGruop);
  }

  obtenerInformacionDelUsuario() {
    this._tallasService.obtenerDatosUsuario(this.obtenerIDUsuarioDatosLocales()).subscribe({
      next: (user: User) => {
        // console.log('Datos del usuario : ', user);
        this.user = user;
        this.user.contrasenna = '';
        this.cargarInforacionUsuarioEnformulario()
      },
      error: (error: any) => {
        console.log('Error obteniendo información del usuario: ', error);
        this.errorMessage = error;
      }
    });
  }
  removeMascota() {
    this.informacionNuevasMascotas.removeAt(this.informacionNuevasMascotas.length - 1);
  }
  cargarInforacionUsuarioEnformulario() {
    this.datosDeUsuarioForm = this._formBuilder.group({
      id: [''],
      nombre: [this.user.nombre, [Validators.required]],
      contrasena: [this.user.contrasenna, Validators.required],
      correo: [this.user.correo, [Validators.required, Validators.email]],
      preguntaSeguridad: [this.user.preguntaSeguridad, Validators.required],
      respuestaSeguridad: ['', Validators.required],
      numeroTelefono: [this.user.numeroTelefono, Validators.required]
    });

  }
  obtenerTallasMascotas() {
    this._tallasService.getTallas().subscribe({
      next: (tallas: Talla[]) => {
        console.log('Tallas: ', tallas);
        return tallas;
      },
      error: (error: any) => {
        console.log("Error obteniendo tallas: ", error);
      }
    });
  }
  obtenerRazaMascotas() {
    this._razaService.getRazas().subscribe({
      next: (razas: Raza[]) => {
        console.log('razas: ', razas);
        return razas;
      },
      error: (error: any) => {
        console.log("Error obteniendo razas: ", error);
      }
    });
  }

  solicitarOtpParaActualziacionDatosUsuario() {
    const datosUsuarioFormData: FormGroup = this.datosDeUsuarioForm;
    const nombre = datosUsuarioFormData.get('nombre').value;

    // El form puede estar vacío si la carga asíncrona del usuario no completó.
    // Fallback: this.user (si ya cargó) → localStorage (siempre disponible tras login).
    let correo: string = datosUsuarioFormData.get('correo').value;
    if (!correo || correo.trim() === '') {
      correo = this.user?.correo ?? '';
    }
    if (!correo || correo.trim() === '') {
      try {
        const session = JSON.parse(localStorage.getItem('userSession') || '{}');
        correo = session?.correo ?? '';
      } catch (_) { correo = ''; }
    }

    if (!correo || correo.trim() === '') {
      alert('El correo electrónico es requerido para continuar.');
      return;
    }

    this._consultaService.solicitarOtpParaActualizarLosDatos(correo.trim())
      .subscribe({
        next: (validate: ResponseValidateOtp) => {
          console.log('respuesta del servicio: ' + validate.messages);
          alert(validate.messages);
          this.openDialogVerifyOtp(correo.trim(), nombre);
        },
        error: (error) => {
          console.error('Error al validar el usuario:', error);
          alert(`Error al validar el usuario`);
        }
      });
  }

  async actualizarDatosMascotas() {
    this.informacionMascotas.controls.forEach(async mascotaFormGroup => {
      const datosMascotaActualizar: DatosMascotaActualizar = {
        id: mascotaFormGroup.get('idMascota').value,
        nombre: mascotaFormGroup.get('nombre').value,
        idRaza: mascotaFormGroup.get('idRaza').value,
        idTalla: mascotaFormGroup.get('idTalla').value,
        idUsuario: this.obtenerIDUsuarioDatosLocales(),
        estado: true
      };

      // Llama a tu servicio para actualizar los datos de la mascota
      await this._mascotaService.actualizarMascota(datosMascotaActualizar)
        .subscribe({
          next: (mascotaActualizada) => {
            alert(`Los datos de ${mascotaActualizada.nombre} fueron actualizados`)
          },
          error: (error) => {
            alert(`Error editando actualizando mascota`)

          }
        });
    });
    await this.cargarDatosPreviosMascotasUsuario();
  }
  confirmarAgregarMascotasNuevas() {
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      data: { message: '¿Está seguro que agregar la o las mascotas?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.agregarNuevaMascota();
      } else {
        alert('NO AGREGAR')
      }
    });
  }
  async agregarNuevaMascota() {
    console.log('mascota agregada');

    const nuevasMascotas: DatosMascotaActualizar[] = [];

    await this.informacionNuevasMascotas.controls.forEach(mascotaFormGroup => {
      const datosMascotaActualizar: DatosMascotaActualizar = {
        id: mascotaFormGroup.get('idMascota').value,
        nombre: mascotaFormGroup.get('nombre').value,
        idRaza: mascotaFormGroup.get('idRaza').value,
        idTalla: mascotaFormGroup.get('idTalla').value,
        idUsuario: this.obtenerIDUsuarioDatosLocales(),
        estado: true
      };
      nuevasMascotas.push(datosMascotaActualizar);
    });
    try {
      await this._mascotaService.agregarListaMascotasNuevas(nuevasMascotas)
        .subscribe(() => {
          this.cargarDatosPreviosMascotasUsuario();
          alert("Datos Actualizados");
          this.informacionNuevasMascotas.clear();
        });

      console.log('Lista de nuevas mascotas:', nuevasMascotas);

    } catch (error) {
      console.error('Error al agregar mascotas:', error);
      // Manejar el error, por ejemplo, mostrar un mensaje al usuario
    }
  }

  acutalizarDatosDeUsuario() {
    //console.log("acutalizarDatosDeUsuario()");
    const datosUsuarioFormData: FormGroup = this.datosDeUsuarioForm;
    this.datosUsuario = {
      id: this.obtenerIDUsuarioDatosLocales(),
      nombre: datosUsuarioFormData.get('nombre').value,
      contrasena: datosUsuarioFormData.get('contrasena').value,
      correo: datosUsuarioFormData.get('correo').value,
      preguntaSeguridad: datosUsuarioFormData.get('preguntaSeguridad').value || undefined,
      respuestaSeguridad: datosUsuarioFormData.get('respuestaSeguridad').value || undefined,
      numeroTelefono: datosUsuarioFormData.get('numeroTelefono').value
    };
    this._consultaService.actualizarDatosDelUsuario(this.datosUsuario)
      .subscribe(() => {
        alert("Datos Actualizados");
      });

    console.log('datos: ', this.datosUsuario);
  }

  async validarPreguntaDeseguridad() {
    const datosUsuarioFormData: FormGroup = this.datosDeUsuarioForm;
    const id = this.obtenerIDUsuarioDatosLocales();
    const respuestaSeguridad = datosUsuarioFormData.get('respuestaSeguridad').value;
    console.log('idUsuario:', id);
    console.log('respuesta:', respuestaSeguridad);

    await this._consultaService.verificarPreguntaDeSeguridadParaActualizarLosDatos(id, respuestaSeguridad)
    .subscribe({
      next: (data: any) => {
        console.log('Datos del usuario : ', data.validacion);
        if(data.validacion){
          alert(data.responseValidacion)
          this.preguntaSeguridadValidada = true;
        }else{
          alert('Respuesta de seguridad incorrecta')
        }
        
      },
      error: (error: any) => {
        console.log('Error obteniendo: ', error);
        alert('ERROR EN LA OPERACIONS')
      }
    });
  }
  // MODAL:
  openDialogVerifyOtp(email, phone): void {
    const dialogRef = this._dialog.open(ConfirmOtpEmailComponent, {
      data: { correo: email, telefono: phone, actualizacion: true },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._consultaService.verificarOtpParaActualizarLosDatos(email, result)
          .subscribe({
            next: (validate: ResponseValidateOtp) => {
              alert(validate.messages);
              this.otpValidado = true;
              this.temporizador();
              this._authService.obtenerPreguntaSeguridad(email).subscribe({
                next: (datos: DatosRecuperacionContrasenna) => {
                  if (datos?.pregunta) {
                    this.datosDeUsuarioForm.get('preguntaSeguridad')?.setValue(datos.pregunta);
                  }
                },
                error: () => { /* silencioso — el campo queda editable */ }
              });
            },
            error: (error) => {
              console.error('Error al validar el OTP:', error);
              alert(`Código incorrecto o expirado. Por favor solicita un nuevo token.`);
            }
          });
      } else {
        alert('ERROR EN LA OPERACIÓN');
      }
      return;
    });
  }
}
